import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { AuthShell, inputClass } from "./Login";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set new password" subtitle="Almost there">
      {!token ? (
        <div className="text-center space-y-4">
          <p className="text-slate-300 text-sm">This reset link is invalid or missing a token.</p>
          <Link to="/forgot-password" className="inline-flex items-center gap-2 text-blue-500 hover:text-blue-400 text-sm">
            <ArrowLeft className="w-4 h-4" /> Request a new link
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && (
            <div className="text-sm text-red-400 bg-red-950/40 border border-red-900/60 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <div>
            <label className="text-xs text-slate-400 mb-1.5 block">New password</label>
            <input
              data-testid="reset-password-input"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              className={inputClass}
            />
          </div>
          <button
            data-testid="reset-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl py-3 flex items-center justify-center transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Reset password"}
          </button>
          <Link to="/login" className="flex items-center justify-center gap-2 text-slate-400 hover:text-slate-200 text-sm pt-2">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
